module.exports = __webpack_public_path__ + "img/ShengHong-icon.e2cbc958.png";